import { IStoreAction, STORE } from '../generalTypes'
import { IWithdrawalsAction, IWithdrawalsLoadListByUserPayload } from './withdrawalsActions'
import { WITHDRAWALS_LOAD_LIST_BY_USER } from './withdrawalsTypes'

const initState: {
	listByUser: IWithdrawalsLoadListByUserPayload
} = {
	listByUser: {
		records: undefined,
		pagination: undefined,
		isLoading: false,
		isFailure: false
	}
}

export default (state = initState, action: IWithdrawalsAction | IStoreAction) => {
	switch (action.type) {
		case WITHDRAWALS_LOAD_LIST_BY_USER.START:
			return {
				...state,
				listByUser: {
					...state.listByUser,
					isLoading: true,
					isFailure: false
				}
			}
		case WITHDRAWALS_LOAD_LIST_BY_USER.DONE:
			return {
				...state,
				listByUser: {
					...state.listByUser,
					...action.payload,
					isLoading: false,
					isFailure: false
				}
			}
		case WITHDRAWALS_LOAD_LIST_BY_USER.FAIL:
			return {
				...state,
				listByUser: {
					...state.listByUser,
					isLoading: false,
					isFailure: true
				}
			}
		case WITHDRAWALS_LOAD_LIST_BY_USER.RESET:
			return {
				...state,
				listByUser: {
					...initState.listByUser
				}
			}
		case STORE.RESET:
			return initState
		default:
			return state
	}
}
